<template>
    <v-container fluid>
        <v-row
            align="center"
            no-gutters
        >
            <v-col
                cols="12"
                justify="center"
                sm="8"
            >
                <v-subheader>
                    <h2>Day Batches Post Submission ({{ totalMatches }})</h2>
                </v-subheader>
            </v-col>
            <!--<v-col
                cols="12"
                lg="4"
                sm="6"
            >
                <v-text-field
                    @click:clear="setSearch('')"
                    @input="setSearch"
                    clearable
                    label="Search"
                    prepend-icon="mdi-magnify"
                    single-line
                />
            </v-col>-->
            <v-col
                class="text-right"
                cols="12"
                sm="4"
            >
                <v-btn
                    @click="showMultiSearch = !showMultiSearch"
                    color="secondary darken-1"
                    icon
                >
                    <v-icon v-if="anyMultiSearchInput">mdi-card-search</v-icon>
                    <v-icon v-else>mdi-card-search-outline</v-icon>
                </v-btn>
            </v-col>
        </v-row>
        <v-container class="pb-10">
            <v-row
                justify="center"
                v-if="dayBatchesReducedView === null"
            >
                <v-col
                    :key="i"
                    cols="12"
                    v-for="i in 6"
                >
                    <v-skeleton-loader
                        elevation="4"
                        type="card"
                    ></v-skeleton-loader>
                </v-col>
            </v-row>
            <v-row
                justify="center"
                v-else
            >
                <v-col
                    :key="dayBatchReducedView.id"
                    cols="12"
                    v-for="dayBatchReducedView in dayBatchesReducedView"
                >
                    <v-card
                        class="incident-card fill-height"
                        elevation="4"
                        style="overflow: hidden"
                        @click="loadDayBatchForm(dayBatchReducedView)"
                    >
                        <v-card-title
                            
                        >#{{ dayBatchReducedView.dayBatchNumber }}</v-card-title>
                        <div>
                            <v-card-text class="center-content pa-2">
                                <v-row justify="space-around">
                                    <v-col
                                        class="text-center"
                                        cols="6"
                                        lg="3"
                                        md="4"
                                        xl="2"
                                    >
                                        <v-card class="pa-1 ma-1 fill-height">
                                            Returned Cover Page
                                            <br />
                                            <h3>
                                                <v-icon
                                                    color="success"
                                                    v-if="
                                                        dayBatchReducedView
                                                            .returnedCoverFileId >
                                                        0
                                                    "
                                                >mdi-check</v-icon>
                                                <v-icon
                                                    color="error"
                                                    v-else
                                                >mdi-close</v-icon>
                                            </h3>
                                        </v-card>
                                    </v-col>
                                    <v-col
                                        class="text-center"
                                        cols="6"
                                        lg="3"
                                        md="4"
                                        xl="2"
                                    >
                                        <v-card class="pa-1 ma-1 fill-height">
                                            PODs
                                            <br />
                                            <h3>
                                                {{
                                                dayBatchReducedView.loadedPodsCount + '/' + dayBatchReducedView.claimsCount
                                                }}
                                            </h3>
                                        </v-card>
                                    </v-col>
                                    <v-col
                                        class="text-center"
                                        cols="6"
                                        lg="3"
                                        md="4"
                                        xl="2"
                                    >
                                        <v-card class="pa-1 ma-1 fill-height">
                                            Link Numbers
                                            <br />
                                            <h3>
                                                {{
                                                dayBatchReducedView.loadedLinkNumbersCount + '/' + dayBatchReducedView.claimsCount
                                                }}
                                            </h3>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </div>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
        <!--MultiSeardch SECTION-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-->
        <v-dialog
            v-model="showMultiSearch"
            width="350px"
        >
            <multi-search-input-form
                :fields="multiSearchFields"
                @close="showMultiSearch = false"
                @reset="multiSearch"
                @search="multiSearch"
            />
        </v-dialog>
        <!--EDIT FORM SECTION-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-->
        <v-dialog
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
            v-model="dayBatchFormVisible"
        >
            <v-sheet
                class="base-background"
                min-height="100%"
            >
                <v-toolbar
                    color="secondary darken-1"
                    dark
                >
                    <v-btn
                        @click="closeDayBatchForm"
                        dark
                        icon
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Day Batch Details</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-container>
                    <DayBatchPostSubmissionForm
                        :day-batch-in="dayBatchFormId"
                        :day-batch-number="dayBatchFormDayBatchNumber"
                        :key="dayBatchFormId"
                        :multi-search-in="multiSearchValues"
                        @close="closeDayBatchForm"
                        @deleted ="updateDayBatch"
                        @saved ="deleteDayBatch"
                        @notify="notify"
                    />
                </v-container>
                            <v-snackbar
                                :color="notifyColor"
                                :timeout="15000"
                                top
                                v-model="notifyShow"
                            >
                                {{ notifyMessage }}
                                <template v-slot:action="{ attrs }">
                                    <v-btn
                                        @click="notifyShow = false"
                                        class="text-none"
                                        icon
                                        v-bind="attrs"
                                    >
                                        <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                </template>
                            </v-snackbar>
            </v-sheet>
        </v-dialog>
        <!--FILTER SECTION-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-->
        <v-dialog
            transition="scroll-x-reverse-transition"
            v-model="showFilters"
            width="350px"
        >
            <v-card>
                <v-card-title>DayBatch Filtering</v-card-title>
                <v-card-text>
                    <v-divider class="mt-3 mb-8"></v-divider>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        @click="resetFilters"
                        class="text-none"
                        color="secondary darken-1"
                        text
                    >Reset</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        @click="showFilters = !showFilters"
                        class="text-none"
                        color="secondary darken-1"
                        text
                    >Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!--PAGINATION SECTION-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-->
        <v-pagination
            :length="pagesCount"
            @input="paginationDebounce(500)"
            class="pagination-bar base-background"
            total-visible="7"
            v-model="pageNo"
            v-show="pagesCount > 1"
        ></v-pagination>
    </v-container>
</template>

<script>
import DayBatchPostSubmissionForm from "../components/forms/DayBatchPostSubmissionForm";
import MultiSearchInputForm from "../components/forms/MultiSearchInputForm";
import dateToString from "../helpers/dateToString";
import uuid4 from "../helpers/uuid4";

export default {
    name: "DayBatches",
    props: [
        "providerId",
        "areaId",
        "agedDaysMin",
        "agedDaysMax",
        "allPrinted",
        "allPod",
        "allLink"
    ],
    data: function() {
        return {
            //main data
            dayBatchesReducedView: null,
            //pagination
            pageNo: 1,
            pageSize: 6,
            pagesCount: 0,
            searchString: "",
            orderBy: "",
            sortOrder: 0,
            paginationTimeout: null,
            requestId: uuid4(),
            totalMatches: null,

            //form data
            dayBatchFormVisible: false,
            dayBatchFormId: null,
            dayBatchFormDayBatchNumber: null,

            providers: [],

            //filters
            filterProviderId: this.providerId > 0 ? this.providerId : null,
            filterAreaId: this.areaId > 0 ? this.areaId : null,
            showFilters: false,
            filterDebounceTime: 500,

            showMultiSearch: false,
            multiSearchFields: [
                { display: "DayBatchNumber #", property: "dayBatchNumber" },
                { display: "Claim #", property: "claimId" },
                { display: "Link Number", property: "linkNumber" },
                { display: "Provider Name", property: "providerName" },
                { display: "Account #", property: "accountId" },
                { display: "Patient Name", property: "patientName" },
                { display: "Patient Surname", property: "patientSurname" },
                {
                    display: "Patient Identity Number",
                    property: "patientIdentityNumber"
                },
                { display: "Grv Number", property: "grvNumber" },
                { display: "Invoice Number", property: "invoiceNumber" }
            ],
            multiSearchValues: [],

            notifyShow: null,
            notifyMessage: null,
            notifyColor: null,
            //
        };
    },
    created: async function() {
        this.getDayBatches();
    },
    mounted: function() {
        this.multiSearchValues = this.multiSearchFields.map(function(x) {
            return { display: x.display, property: x.property, value: x.value };
        });
    },
    components: {
        DayBatchPostSubmissionForm,
        MultiSearchInputForm
        //
    },
    computed: {
        anyMultiSearchInput: function() {
            return this.multiSearchValues.some(
                x => x.value != "" && x.value != null
            );
        }
        //
    },
    methods: {
        notify(message, color) {
            this.notifyShow = true;
            this.notifyMessage = message;
            this.notifyColor = color;
        },
        multiSearch(values) {
            this.multiSearchValues = values;
            this.searchString = "";
            this.pageNo = 1;
            this.pagesCount = 0;
            this.paginationDebounce(0);
        },
        async getDayBatches() {
            var requestId = (this.requestId = uuid4());

            var urlParameters = {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                searchString: this.searchString,
                orderBy: this.orderBy,
                sortOrder: this.sortOrder,
                isSubmitted: true,
                providerId: this.filterProviderId
                    ? this.filterProviderId
                    : null,
                areaId: this.filterAreaId ? this.filterAreaId : null,
                //NEW ONES TO BE ADDED TO FILTER GUI AND FILTER RESET
                agedDaysMin: this.agedDaysMin ? this.agedDaysMin : null,
                agedDaysMax: this.agedDaysMax ? this.agedDaysMax : null,
                allPrinted:
                    this.allPrinted !== undefined ? this.allPrinted : null,
                allPod: this.allPod !== undefined ? this.allPod : null,
                allLink: this.allLink !== undefined ? this.allLink : null
            };

            this.multiSearchValues
                .filter(x => x.value != "" && x.value != null)
                .forEach(x => (urlParameters[x.property] = x.value));

            var dayBatchesResponse = await this.$store.dispatch(
                "dayBatches/getpostsubmissionreducedview",
                {
                    id: null,
                    urlParameters,
                    requestId: requestId
                }
            );

            if (this.requestId == dayBatchesResponse.requestId) {
                //dayBatchesResponse.data.page.forEach(x =>this.dayBatchApplyDisciplineName(x.entity));
                this.dayBatchesReducedView = dayBatchesResponse.data.page;
                this.totalMatches = dayBatchesResponse.data.total;
                this.pagesCount = Math.ceil(
                    dayBatchesResponse.data.total / this.pageSize
                );
            }
        },
        paginationDebounce(debounceTime) {
            if (this.dayBatchesReducedView !== null)
                this.dayBatchesReducedView = null;
            clearTimeout(this.paginationTimeout);
            this.paginationTimeout = setTimeout(
                this.getDayBatches,
                debounceTime
            );
        },
        setSearch(value) {
            this.searchString = value;
            this.pageNo = 1;
            this.pagesCount = 0;
            this.paginationDebounce(1000);
        },
        resetFilters() {
            this.filterProviderId = null;
            this.filterPatient = null;
            this.paginationDebounce(0);
        },
        loadDayBatchForm(dayBatch) {
            this.dayBatchFormId = dayBatch.id;
            this.dayBatchFormDayBatchNumber = dayBatch.dayBatchNumber;
            this.dayBatchFormVisible = true;
        },
        closeDayBatchForm() {
            this.dayBatchFormVisible = false;
            this.dayBatchFormId = null;
            this.dayBatchFormDayBatchNumber = null;
        },
        updateDayBatch() {
            this.paginationDebounce(0);
        },
        deleteDayBatch() {
            this.paginationDebounce(0);
        },
        dateToString(date) {
            return dateToString(date ? new Date(date) : null);
        },
        podsUploaded(dayBatch) {
            /*
            var podFileIds = dayBatch.claims.flatMap(x => x.accounts).map(x => x.podFileId);
            return  podFileIds.filter(x => x > 0).length + "/" + podFileIds.length;
            */
            var podFileIds = dayBatch.claims.map(x => x.podFileId);
            return (
                podFileIds.filter(x => x > 0).length + "/" + podFileIds.length
            );
        },

        linkNumbersSet(dayBatch) {
            var linkNumbers = dayBatch.claims.map(x => x.linkNumber);
            return (
                linkNumbers.filter(x => !!x).length + "/" + linkNumbers.length
            );
        }
    }
};
</script>

<style lang="stylus" scoped>
.incident-card {
    /* background: linear-gradient(45deg, rgba(127,127,127,0.1), transparent,rgba(127,127,127,0.1)) */
    .center-content {
        background-color: rgba(127, 127, 127, 0.15);
    }
}

.theme--dark {
    .patient-panel {
        .v-card {
            background-color: rgba(127, 127, 127, 0.1);
        }
    }
}

.pagination-bar {
    // position: fixed;
    bottom: 0;
    margin: auto;
    left: 0;
    right: 0;
    padding-bottom: 0.1rem;
    padding-top: 0.1rem;
    /*
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    border:1px solid rgba(127, 127, 127, 0.2)
    */
}

.theme--light {
    .base-background {
        background: #FFFFFF;
    }
}

.theme--dark {
    .base-background {
        background: #121212;
    }
}
</style>
